import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import projectService from "../services/projectService";
import "../styles/Dashboard.css";

function ProjectList() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      if (!auth.currentUser) return;
      try {
        const data = await projectService.fetchMyProjects(auth.currentUser.uid);
        // Sort by deadline or creation date if needed, taking top 3 for "Recent"
        setProjects(data.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch projects", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const getProgress = (status) => {
    switch (status) {
      case "Assigned": return 25;
      case "In Progress": return 50;
      case "QA": return 75;
      case "Completed": return 100;
      default: return 0;
    }
  };

  if (loading) {
    return <p>Loading projects...</p>;
  }

  if (projects.length === 0) {
    return (
      <div className="project-list">
        <p className="no-projects">No recent projects</p>
        <div className="view-all-container">
          <button
            className="view-all-btn"
            onClick={() => navigate("/available-projects")}
          >
            Browse Projects →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="project-list">
      {projects.map((project) => {
        const progress = getProgress(project.status);
        return (
          <div key={project._id} className="project-card">
            <h4>{project.title}</h4>
            <p className="project-meta">Status: {project.status}</p>
            <div className="progress-container">
              <div
                className="progress-bar"
                style={{ "--progress": `${progress}%`, width: `${progress}%` }}
              ></div>
              <span className="progress-percentage">{progress}%</span>
            </div>
            <p className="project-due">Due: {project.deadline || "No deadline"}</p>
          </div>
        );
      })}

      <div className="view-all-container">
        <button
          className="view-all-btn"
          onClick={() => navigate("/my-projects")}
        >
          View All Projects →
        </button>
      </div>
    </div>
  );
}

export default ProjectList;
